import React, { useState } from "react";
import AnimatedTextInput from "./animatedTextInput";
import { useTranslation, Trans } from "react-i18next";
import { stripNumbers } from "../utils";

function NameInput({ question, onSubmitHandler, nameDetails = null }) {
  const [name, setName] = useState(
    nameDetails || {
      first: "",
      middle: "",
      last: "",
    }
  );
  const { t } = useTranslation();

  const handleChange = (e) => {
    const { id, value } = e.target;
    setName((prevState) => ({
      ...prevState,
      [id]: stripNumbers(value),
    }));
  };

  const inputMissing = () => !(name.first && name.last);
  return (
    <div className="body_content">
      <div className="inner_body ">
        <h3 className="headtitle">{question}</h3>
        <div className="fill_form light_fill_form">
          <AnimatedTextInput
            label={t("onboard.NAME.firstNameLbl")}
            value={name.first.charAt(0).toUpperCase() + name.first.slice(1)}
            onChange={handleChange}
            id="first"
            isFocused={true}
            isTextOnly={true}
          />
          <AnimatedTextInput
            label={t("onboard.NAME.middleNameLbl")}
            value={name.middle.charAt(0).toUpperCase() + name.middle.slice(1)}
            onChange={handleChange}
            id="middle"
            isTextOnly={true}
          />
          <AnimatedTextInput
            label={t("onboard.NAME.lastNameLbl")}
            value={name.last.charAt(0).toUpperCase() + name.last.slice(1)}
            onChange={handleChange}
            id="last"
            isTextOnly={true}
          />
          <div className="btn_block d-flex justify-content-center bottom_button">
            <button
              className="btn btn_primary nextstep_cta"
              disabled={inputMissing()}
              onClick={() => onSubmitHandler(name)}
            >
              {t("login.DOBSTEP.button")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NameInput;
